// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class OptionalPageSelection {
  coverPage: boolean;
  exclusions: boolean;
  termsConditions: boolean;
  scopeOfWork: boolean;
  clarifications: boolean;
  drawingsSpecDates: boolean;
  inclusions: boolean;
  proposedSolutions: boolean;
  pageReferences: boolean;
  financialOptions: boolean;
  isUseTemplatePageDefault: boolean;
  paymentTerms: boolean;
  signaturePage: boolean;
}
